module.exports = "/img/logo.ae399782.png";